import { createAction } from "redux-starter-kit";
import {
  TOC_PANEL_START_LOAD,
  TOC_PANEL_END_LOAD,
  TOC_PANEL_LOAD_FAIL,
  TOC_PANEL_MODIFY_ONE_ITEM,
  TOC_PANEL_RECOVER,
  TOC_PANEL_STATE_SNAPSHOT,
  TOC_PANEL_DELETE_ARTICLE,
  TOC_PANEL_APPEND_ARTICLE,
  TOC_PANEL_API_SET_ARTICLE_TITLE,
  TOC_PANEL_MANUAL_CREATE_ARTICLE,
  TOC_PANEL_MERGE_ARTICLE,
  TOC_PANEL_SAVE_LOADING,
  TOC_PANEL_LOCK_ITEM,
  TOC_PANEL_MERGE_TO_LOCK,
  TOC_PANEL_CHANGE_MODE,
  TOC_PANEL_ENTER_DESCRIPTION,
  TOC_PANEL_API_SET_ARTICLE_READY
} from "../actionTypes";
import Moment from "moment";
import { getArticlesApi, saveTocApi } from "../../api/articles";
import { updateIssueMetaApi } from "../../api/issues";
import { changeTextLineIDsObjectForApi } from "../../api/apiUtils";
import { mergePageTextLineApi } from "../../api/pages";
import { generateUniqueID } from "../../utils/utils";
import { debounce } from "debounce";

export const startLoadArticlesAction = createAction(TOC_PANEL_START_LOAD);
export const endLoadArticlesAction = createAction(TOC_PANEL_END_LOAD);
export const articlesFailLoadAction = createAction(TOC_PANEL_LOAD_FAIL);
export const modifyOneTocDataAction = createAction(TOC_PANEL_MODIFY_ONE_ITEM);
export const recoverLastMoveAction = createAction(TOC_PANEL_RECOVER);
export const snapShotTocStateAction = createAction(TOC_PANEL_STATE_SNAPSHOT);
export const deleteTocArticleAction = createAction(TOC_PANEL_DELETE_ARTICLE);
export const appendTocArticleAction = createAction(TOC_PANEL_APPEND_ARTICLE);
export const apiSetTocArticleTitleAction = createAction(
  TOC_PANEL_API_SET_ARTICLE_TITLE
);
export const apiSetTocArticleReadyAction = createAction(
  TOC_PANEL_API_SET_ARTICLE_READY
);
export const createManualArticleAction = createAction(
  TOC_PANEL_MANUAL_CREATE_ARTICLE
);
export const mergeArticleAction = createAction(TOC_PANEL_MERGE_ARTICLE);
export const setSaveLoadingAction = createAction(TOC_PANEL_SAVE_LOADING);
export const setLockingIDAction = createAction(TOC_PANEL_LOCK_ITEM);
export const mergeToLockArticleAction = createAction(TOC_PANEL_MERGE_TO_LOCK);
export const changeTocModeAction = createAction(TOC_PANEL_CHANGE_MODE);
export const enterIssueDescriptionAction = createAction(
  TOC_PANEL_ENTER_DESCRIPTION
);

function saveTempTocImpl(issueID, articleIDs, articlesDict) {
  const articles = articleIDs.map(anArticleID => articlesDict[anArticleID]);

  window.localStorage.setItem("toc-" + issueID, JSON.stringify(articles));
}

const delayedSaveTempTocImpl = debounce(saveTempTocImpl, 1500);

export function saveTempTocAction(issueID) {
  return async (dispatch, getState) => {
    const { tocEditPanel } = getState();
    const { saveTemp, editHistory } = tocEditPanel;

    if (!saveTemp || editHistory.length <= 0) {
      return;
    }

    const { articleIDs, articlesDict } = editHistory[editHistory.length - 1];

    delayedSaveTempTocImpl(issueID, articleIDs, articlesDict);
  };
}

export function loadArticlesRequestAction(issueID) {
  return async dispatch => {
    dispatch(startLoadArticlesAction({ issueID }));

    try {
      let articles = await getArticlesApi(issueID, true);

      if (articles.length <= 0) {
        const savedJson = window.localStorage.getItem("toc-" + issueID);

        let savedArticles = [];

        try {
          savedArticles = JSON.parse(savedJson);
        } catch (e) {
          console.log(e.toString());
        }

        if (savedArticles != null && savedArticles.length > 0) {
          dispatch(
            endLoadArticlesAction({
              issueID,
              articles: savedArticles,
              saveTemp: true
            })
          );
        } else {
          dispatch(
            endLoadArticlesAction({ issueID, articles, saveTemp: true })
          );
          dispatch(
            createManualArticleAction({
              newID: generateUniqueID(),
              insertIndex: 0,
              title: "猜猜我是誰？（封面/表紙/표지/Cover）"
            })
          );
        }
      } else {
        window.localStorage.removeItem("toc-" + issueID);
        dispatch(endLoadArticlesAction({ issueID, articles, saveTemp: false }));
      }
    } catch (e) {
      dispatch(articlesFailLoadAction({ issueID, errMsg: e.toString() }));
    }
  };
}

export function saveIssueDesRequestAction(issueID, issue, description, toast) {
  return async (dispatch, getState) => {
    dispatch(setSaveLoadingAction({ isSaveLoading: true }));

    const dateFormat = "YYYY-MM-DDTHH:mm:SS";
    const availableFrom =
      issue.available_from != null
        ? Moment(issue.available_from * 1000).format(dateFormat)
        : "";
    const availableTo =
      issue.available_to != null
        ? Moment(issue.available_to * 1000).format(dateFormat)
        : "";
    const offShelfAt =
      issue.off_shelf_at != null
        ? Moment(issue.off_shelf_at * 1000).format(dateFormat)
        : "";
    const publishAt =
      issue.published_at != null
        ? Moment(issue.published_at * 1000).format(dateFormat)
        : "";

    try {
      let metaData = {
        issueName: issue.issue == null ? "" : issue.issue,
        description: description,
        isAdult: issue.is_adult == null ? false : issue.is_adult,
        year: issue.year == null ? "" : issue.year,

        publishAt: publishAt,
        offShelfAt: offShelfAt,
        availableFrom: availableFrom,
        availableTo: availableTo,

        productID: issue.product_id == null ? "" : issue.product_id,
        contentsID: issue.content_id == null ? "" : issue.content_id,

        pubuProductID:
          issue.pubu_product_id == null ? "" : issue.pubu_product_id,
        pubuProductCategory:
          issue.pubu_product_category == null
            ? ""
            : issue.pubu_product_category,
        cover: null,
        isLeftFlip: issue.is_left_flip
      };

      try {
        await updateIssueMetaApi(issueID, true, metaData);
      } catch (e) {
        toast.error(e.toString());
      }

      dispatch(setSaveLoadingAction({ isSaveLoading: false }));

      const parentPath = window.location.href.substring(
        0,
        window.location.href.length - 4
      );
      window.location.assign(parentPath);
    } catch (e) {
      dispatch(setSaveLoadingAction({ isSaveLoading: false }));
      toast.error(e.toString());
    }
  };
}

export function saveTocRequestAction(issueID, articleIDs, lastPage, toast) {
  return async (dispatch, getState) => {
    dispatch(setSaveLoadingAction({ isSaveLoading: true }));

    try {
      const state = getState().tocEditPanel;
      const { articlesDict } = state.editHistory[state.editHistory.length - 1];

      const tocs = articleIDs.map(articleID => {
        const article = articlesDict[articleID];

        let toBeReturned = {
          title: article.title,
          first_page: article.first_page,
          last_page: article.last_page
        };

        if (!articleID.startsWith("client-")) {
          toBeReturned["article_id"] = articleID;
        }

        const jsonTextLineIDs = changeTextLineIDsObjectForApi(
          article.textLineIDs
        );
        if (jsonTextLineIDs != null) {
          toBeReturned.text_line_ids = jsonTextLineIDs;
        }

        if (article.orderedTextLineIDs != null) {
          toBeReturned.ordered_text_line_ids = article.orderedTextLineIDs.map(
            aTextLineIDs => changeTextLineIDsObjectForApi(aTextLineIDs)
          );
        }

        return toBeReturned;
      });

      if (tocs.length > 0) {
        for (let i = 0; i < tocs.length; i++) {
          const aToc = tocs[i];

          if (Number(aToc.last_page) < Number(aToc.first_page)) {
            throw Error(`Last page error in toc #${i + 1}`);
          }
        }
      } else {
        throw Error("No Toc");
      }

      await saveTocApi(issueID, tocs);

      toast.success("Save Success");
      dispatch(setSaveLoadingAction({ isSaveLoading: false }));
      dispatch(loadArticlesRequestAction(issueID));

      window.localStorage.removeItem("toc-" + issueID);

      const parentPath = window.location.href.substring(
        0,
        window.location.href.length - 4
      );
      window.location.assign(parentPath);
    } catch (e) {
      dispatch(setSaveLoadingAction({ isSaveLoading: false }));
      toast.error(e.toString());
    }
  };
}

async function appendIssueDescription(
  dispatch,
  textLineIDs,
  issueID,
  currentDescription
) {
  try {
    let combinedText = await mergePageTextLineApi(issueID, textLineIDs);

    dispatch(
      enterIssueDescriptionAction({
        description: currentDescription + combinedText.result + "\n"
      })
    );
  } catch (e) {
    console.log(e.toString());
  }
}

async function appendTocArticle(dispatch, newID, page, textLineIDs, issueID) {
  dispatch(
    appendTocArticleAction({
      textLineIDs,
      newID,
      page,
      timeStamp: Date.now()
    })
  );

  try {
    let combinedText = await mergePageTextLineApi(issueID, textLineIDs);

    dispatch(
      apiSetTocArticleTitleAction({
        id: newID,
        title: combinedText.result,
        ready: true,
        orderedTextLineIDs: []
      })
    );
  } catch (e) {
    dispatch(
      apiSetTocArticleTitleAction({ id: newID, title: "ERROR", ready: false })
    );
  }
}

async function mergeToLockTocArticleNoReorder(
  dispatch,
  getState,
  lockingID,
  page,
  textLineIDs,
  issueID
) {
  const state = getState().tocEditPanel;
  const { articlesDict } = state.editHistory[state.editHistory.length - 1];

  const toArticle = articlesDict[lockingID];

  if (toArticle == null) {
    dispatch(setLockingIDAction({ lockingID: null }));
    return;
  }

  const oldTitle = toArticle.title;

  dispatch(
    mergeToLockArticleAction({
      textLineIDs,
      toID: lockingID,
      ordered: true
    })
  );

  try {
    let combinedText = await mergePageTextLineApi(issueID, textLineIDs);

    dispatch(
      apiSetTocArticleTitleAction({
        id: lockingID,
        title: oldTitle + combinedText.result,
        ready: true
      })
    );
  } catch (e) {
    dispatch(
      apiSetTocArticleTitleAction({
        id: lockingID,
        title: "ERROR",
        ready: false
      })
    );
  }
}

async function mergeToLockTocArticle(
  dispatch,
  getState,
  lockingID,
  page,
  textLineIDs,
  issueID
) {
  dispatch(
    mergeToLockArticleAction({
      textLineIDs,
      toID: lockingID
    })
  );

  try {
    const state = getState().tocEditPanel;
    const { articlesDict } = state.editHistory[state.editHistory.length - 1];

    const toArticle = articlesDict[lockingID];

    if (toArticle == null) {
      dispatch(setLockingIDAction({ lockingID: null }));
      return;
    }

    let combinedText = await mergePageTextLineApi(
      issueID,
      toArticle.textLineIDs
    );

    dispatch(
      apiSetTocArticleTitleAction({
        id: lockingID,
        title: combinedText.result,
        ready: true,
        orderedTextLineIDs: []
      })
    );
  } catch (e) {
    dispatch(
      apiSetTocArticleTitleAction({
        id: lockingID,
        title: "ERROR",
        ready: false
      })
    );
  }
}

export function orderedSendToTocArticleRequestAction(
  page,
  textLineIDs,
  issueID,
  toast
) {
  if (textLineIDs.length < 0) {
    return;
  }

  return async (dispatch, getState) => {
    const lockingID = getState().tocEditPanel.lockingID;
    const mode = getState().tocEditPanel.mode;
    const currentDes = getState().tocEditPanel.description;

    if (mode !== "toc") {
      await appendIssueDescription(dispatch, textLineIDs, issueID, currentDes);
    } else if (lockingID == null) {
      toast.error("can only send ordered text to a locked item");
      return;
    } else {
      await mergeToLockTocArticleNoReorder(
        dispatch,
        getState,
        lockingID,
        page,
        textLineIDs,
        issueID
      );
      dispatch(saveTempTocAction(issueID));
    }
  };
}

export function appendTocArticleRequestAction(page, textLineIDs, issueID) {
  if (textLineIDs.length < 0) {
    return;
  }

  const newID = generateUniqueID();

  return async (dispatch, getState) => {
    const lockingID = getState().tocEditPanel.lockingID;
    const mode = getState().tocEditPanel.mode;
    const currentDes = getState().tocEditPanel.description;

    if (mode !== "toc") {
      await appendIssueDescription(dispatch, textLineIDs, issueID, currentDes);
    } else if (lockingID == null) {
      await appendTocArticle(dispatch, newID, page, textLineIDs, issueID);
      dispatch(saveTempTocAction(issueID));
    } else {
      await mergeToLockTocArticle(
        dispatch,
        getState,
        lockingID,
        page,
        textLineIDs,
        issueID
      );
      dispatch(saveTempTocAction(issueID));
    }
  };
}

export function mergeTocArticleRequestAction(
  fromArticle,
  toArticle,
  issueID,
  concatOnly
) {
  const newTextLineIDs = combineTextLineIDs(fromArticle, toArticle);
  const newOrderedTextLineIDs = combineOrderedTextLineIDs(
    toArticle,
    fromArticle
  );

  return async dispatch => {
    dispatch(
      mergeArticleAction({
        fromID: fromArticle.id,
        toID: toArticle.id,
        newTextLineIDs: newTextLineIDs,
        newOrderedTextLineIDs
      })
    );

    if (fromArticle.textLineIDs == null || toArticle.textLineIDs == null) {
      dispatch(apiSetTocArticleReadyAction({ id: toArticle.id, ready: true }));
      dispatch(saveTempTocAction(issueID));
      return;
    }

    if (newTextLineIDs == null) {
      dispatch(apiSetTocArticleReadyAction({ id: toArticle.id, ready: true }));
      dispatch(saveTempTocAction(issueID));
      return;
    }

    const pageIDArr = Object.keys(newTextLineIDs);
    if (pageIDArr.length <= 0) {
      dispatch(apiSetTocArticleReadyAction({ id: toArticle.id, ready: true }));
      dispatch(saveTempTocAction(issueID));
      return;
    }

    if (concatOnly) {
      dispatch(apiSetTocArticleReadyAction({ id: toArticle.id, ready: true }));
      dispatch(saveTempTocAction(issueID));
      return;
    }

    try {
      let combinedText = await mergePageTextLineApi(issueID, newTextLineIDs);

      dispatch(
        apiSetTocArticleTitleAction({
          id: toArticle.id,
          title: combinedText.result,
          ready: true,
          orderedTextLineIDs: []
        })
      );
      dispatch(saveTempTocAction(issueID));
    } catch (e) {
      dispatch(
        apiSetTocArticleTitleAction({
          id: toArticle.id,
          title: "ERROR",
          ready: false
        })
      );
    }
  };
}

function combineTextLineIDs(fromArticle, toArticle) {
  let combinedTextLineIDs = null;

  if (fromArticle.textLineIDs != null && toArticle.textLineIDs != null) {
    combinedTextLineIDs = {};

    const fromPageIDArr = Object.keys(fromArticle.textLineIDs);
    const toPageIDArr = Object.keys(toArticle.textLineIDs);

    const newPageIDArr = Array.from(new Set(fromPageIDArr.concat(toPageIDArr)));

    let i;
    for (i = 0; i < newPageIDArr.length; i++) {
      const pageID = newPageIDArr[i];

      const fromTextPageData = fromArticle.textLineIDs[pageID];
      const toTextPageData = toArticle.textLineIDs[pageID];

      const fromTextLineIndexes =
        fromTextPageData == null ? null : fromTextPageData.textLineIndexes;
      const toTextLineIndexes =
        toTextPageData == null ? null : toTextPageData.textLineIndexes;

      let combinedLineIndexes = null;

      if (fromTextLineIndexes != null && toTextLineIndexes != null) {
        combinedLineIndexes = Array.from(
          new Set(fromTextLineIndexes.concat(toTextLineIndexes))
        ).sort();
      } else if (fromTextLineIndexes != null) {
        combinedLineIndexes = fromTextLineIndexes;
      } else if (toTextLineIndexes != null) {
        combinedLineIndexes = toTextLineIndexes;
      }

      const data = {
        pageID: pageID,
        textLineIndexes: combinedLineIndexes
      };

      combinedTextLineIDs[pageID] = data;
    }
  } else if (fromArticle.textLineIDs != null) {
    combinedTextLineIDs = fromArticle.textLineIDs;
  } else if (toArticle.textLineIDs != null) {
    combinedTextLineIDs = toArticle.textLineIDs;
  }

  return combinedTextLineIDs;
}

function combineOrderedTextLineIDs(firstItem, secondItem) {
  let result = [];

  if (
    firstItem.orderedTextLineIDs != null &&
    firstItem.orderedTextLineIDs.length > 0
  ) {
    result = result.concat(firstItem.orderedTextLineIDs);
  } else {
    if (firstItem.textLineIDs != null) {
      result.push(firstItem.textLineIDs);
    }
  }

  if (
    secondItem.orderedTextLineIDs != null &&
    secondItem.orderedTextLineIDs.length > 0
  ) {
    result = result.concat(secondItem.orderedTextLineIDs);
  } else {
    if (secondItem.textLineIDs != null) {
      result.push(secondItem.textLineIDs);
    }
  }

  return result;
}
